<template>
  <div class="experts">
    <div class="banner ban_title">
      <h1 class="h1">国内外AI前沿技术专家</h1>
      <p class="p">行业领先的AI技术实践者</p>
    </div>
    <div class="pc_content producer" v-if="global.area_id!=='4288'">
      <div class="con">
        <h1 class="h1">出品人</h1>
        <Lecturers :datalist="global.year>'2020' ? producers : producer" :type="'producer'"></Lecturers>
        <h2 class="moreperson">更多大咖正在邀请确认中……</h2>
      </div>
    </div>
    <div class="pc_content guest">
      <div class="con">
        <h1 class="h1">演讲嘉宾</h1>
        <Lecturers :datalist="guests" :type="'teacher'"></Lecturers>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Experts',
  components: {
    Lecturers: () => import('../componentsNew/Lecturers.vue')
  },
  data () {
    return {
      subject: [],
      producer: [],
      producers: [],
      guests: []
    }
  },
  computed: {
    producerData () {
      return [this.subject, this.producer]
    }
  },
  watch: {
    producerData: {
      handler (_new, _old) {
        // console.log(_new, _old)
        if (_new && _new[0] && _new[1] && (_new[0].length > 0 || _new[1].length > 0) && this.global.year > '2020') {
          let sList = _new[0]
          let pList = _new[1]
          this.producers = []
          if (sList && sList.length > 0) {
            for (var i = 0; i < pList.length; i++) {
              const pId = pList[i].id || ''
              for (let j = 0; j < sList.length; j++) {
                if (pId.toString() === (sList[j].producerId && sList[j].producerId.toString())) {
                  pList[i].subjectId = sList[j].id
                  break
                }
              }
            }
          }
          this.producers = pList
        }
      },
      immediate: true,
      deep: true
    }
  },
  created () {
    this.getSubject()
  },
  methods: {
    getSubject: function () {
      let surl = this.global.urlNew.subject + this.global.area_id
      this.$http.jsonp(surl)
        .then((res) => {
          return res.json()
        })
        .then((res) => {
          // console.log('s ', res, res.errno === '0' && res.data && res.data.length > 0)
          if (res.errno === '0') {
            this.subject = res.data || []
          }
          this.getProducer()
          this.getGuest()
        })
    },
    getProducer: function () {
      let pid = this.global.config[this.global.area_id]['lecturer']
      let purl = this.global.urlNew.sue['lecturer'] + pid
      console.log(pid)
      this.$http.jsonp(purl)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          console.log('p', data, data.errno === '0' && data.data && data.data[pid] && data.data[pid].length > 0)
          if (data.errno === '0') {
            this.producer = (data.data && data.data[pid]) || []
          }
        })
    },
    getGuest: function () {
      let gurl = this.global.urlNew.speaker + this.global.area_id
      this.$http.jsonp(gurl)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          // console.log('experts guests ',data);
          if (data.errno === '0') {
            this.guests = data.data
          }
        })
    }
  }
}
</script>

<style lang="scss">
#app .experts {
  .pc_content {
    .con {
      h1 {
        padding-top: 70px;
        padding-bottom: 70px;
      }
      h2.moreperson {
        padding-top: 100px;
        margin-bottom: 50px;
        text-align: center;
        color: var(--deep-color);
        font-size: 20px;
        font-weight: bold;
        transition: all 0.3s;
      }
    }
  }
  .pc_content.guest {
    border-top: 1px solid #e6e6e6;
    .con {
      margin-bottom: 60px;
    }
  }
}
@media (max-width: 600px) {
  .experts {
    .pc_content {
      .con {
        h1 {
          padding-top: 25px;
          padding-bottom: 30px;
        }
        h2.moreperson {
          font-size: 14px;
          padding-top: 0;
          margin-bottom: 30px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/viewsNew/Experts.vue